"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PcbModelInstance = exports.PcbModelSchema = void 0;
const PcbDrawing_1 = require("./DrawingModels/PcbDrawing");
const Module_1 = require("./DrawingModels/Module");
const Segment_1 = require("./DrawingModels/Segment");
const Circle_1 = require("./DrawingModels/Circle");
const Zone_1 = require("./DrawingModels/Zone");
const Via_1 = require("./DrawingModels/Via");
const Track_1 = require("./DrawingModels/Track");
const ModelBase_1 = require("./ModelBase");
const zod_1 = require("zod");
const metadata_1 = require("./metadata");
exports.PcbModelSchema = (0, ModelBase_1.ModelBaseSchema)(PcbDrawing_1.PcbDrawingSchema).extend({
    modelType: zod_1.default.literal('pcb'),
    edges: zod_1.default.array(zod_1.default.union([Circle_1.CircleSchema, Segment_1.SegmentSchema])),
    throughHoleLayers: zod_1.default.number().array(),
    modules: Module_1.ModuleSchema.array(),
    tracks: zod_1.default.record(zod_1.default.coerce.number(), Track_1.TrackSchema.array()),
    zones: zod_1.default.record(zod_1.default.coerce.number(), Zone_1.ZoneSchema.array()),
    vias: Via_1.ViaSchema.array(),
    metadata: metadata_1.MetadataSchema,
    warnings: zod_1.default.string().array(),
});
class PcbModelInstance extends ModelBase_1.ModelBaseInstance {
    constructor(context, opts) {
        super(context, {
            modelType: 'pcb',
            ...opts,
            metadata: {
                title: '',
                revision: '',
                company: '',
                date: '',
                ...(opts.metadata ?? {}),
            },
        });
        this.edges = [];
        this.throughHoleLayers = [];
        this.modules = [];
        this.tracks = {};
        this.zones = {};
        this.vias = [];
        this.edges = opts.edges ?? [];
        this.throughHoleLayers = opts.throughHoleLayers ?? [];
        this.modules = opts.modules ?? [];
        this.tracks = opts.tracks ?? {};
        this.zones = opts.zones ?? {};
        this.vias = opts.vias ?? [];
    }
    toJSON() {
        return {
            ...this.serializeModelBaseInstanceProps(),
            metadata: structuredClone({
                title: '',
                revision: '',
                company: '',
                date: '',
                ...this.metadata,
            }),
            edges: structuredClone(this.edges),
            throughHoleLayers: structuredClone(this.throughHoleLayers),
            modules: structuredClone(this.modules),
            tracks: structuredClone(this.tracks),
            zones: structuredClone(this.zones),
            vias: structuredClone(this.vias),
        };
    }
}
exports.PcbModelInstance = PcbModelInstance;
//# sourceMappingURL=pcb.js.map